// those file are generate by npm run i18n
  export default {
  "user": {
    "subtitle": "1年の振り返り",
    "note": "*この振り返りの実績は2025/12/31時点のものです。"
  },
  "handCard": {
    "text": "{date}\nこの日は\n2025年のNUTS POKER初プレイ記念日！"
  },
  "report": {
    "loginTime": "それ以来、NUTS POKERを\n{loginDay}\nプレイしてくれましたね！",
    "loginTips": "* 2025年のNUTS POKERログイン日数",
    "enjoyTime": "{loginTime}\nあなたのゴールデンタイム！\nNUTS POKERを開く定番の時間です！",
    "firstHandDate": "{first_hand_date}\n2025年初のハンドを受け取ったのは{first_hand_type}プレイ中でした！\n{first_hand_cards}"
  },
  "hands": {
    "v1": "2025年のNUTS POKERでのプレイ総数は\n{hands}\nあなたのポーカー愛は\n{percentage}のプレイヤーに\n勝るほど！",
    "v2": "2025年のNUTS POKERでのプレイ総数は\n{hands}\nいつもプレイしてくれてありがとう！",
    "v3": "2025年のNUTS POKERでのプレイ総数は\n{hands}\nNUTS POKERは来年も、もっと快適で楽しい体験をお届けします！"
  },
  "hardTime": {
    "date": "{one_day_hands}\nNUTS POKERに\nこの上なく熱中していた日！",
    "hands": "{one_day_hands_num}{longHands}\nプレイしました！"
  },
  "favoriteGame": "そのうち一番没頭していたのは\n{game}\n{handsNum}{hands}プレイしました！",
  "kkWin": {
    "v1": "2025年の\"KK\"獲得回数は\n{all}{longTimes}\n\"KK\"で対戦相手を飛ばしたのは\n{win}{longTimesTwo}",
    "v2": "2025年のオールイン回数は\n{all}{threeTimes}\nオールイン勝率は\n{percentage}\nポーカーは大胆に挑む者が輝くゲーム！"
  },
  "achievement": {
    "spinup": "{spinup_date}は\n最高にツイてる日！",
    "spinup_2": "SpinUpで{spinup_ratio}倍を当てて、\n{spinup_reward}\nを獲得！",
    "mtt": "{mtt_date}には\n最高成績を達成！",
    "mtt_2": "{mtt_name}で堂々の{mtt_rank}{no}！\n{mtt_reward}を獲得！",
    "rg": "{rg_date}\nあなたのポーカー史に刻まれる一幕！",
    "rg_2": "2025年最大のポット\n{rg_reward}\nを獲得！"
  },
  "lucky": {
    "title": "どのハンドにも\n物語がある",
    "luckyHand": "ラッキー\nハンド",
    "unLuckyHand": "アンラッキー\nハンド",
    "luckyRate": "勝率\n{lucky_rate}",
    "unLuckyRate": "勝率\n{unlucky_rate}",
    "luckyText": "{lucky_hand}は主役級ハンド！\nこのハンドなら勝率は{lucky_rate}にも！",
    "unLuckyText": "{unlucky_hand}には要注意！\nこのハンドでの勝率はわずか{unlucky_rate}",
    "note": "*配布回数が10回以上のスターティングハンドのみが対象です。"
  },
  "futureStory": "あなたが2026年に繰り広げる\nポーカー物語を\nNUTS POKERは楽しみにしています！",
  "version3": {
    "text": "残念ながら、2025年はNUTS POKERでの思い出を築くことができなかったようです…",
    "continue": "2026年は、NUTS POKERで\n一緒に物語を描いていこう！",
    "tips": " *全データは2024年12月31日時点のものです。"
  },
  "button": {
    "save": "画像を保存",
    "copy": "コピー＆シェア"
  },
  "unit": {
    "days": "日間",
    "hands": "ハンド",
    "longHands": "ハンド",
    "longTimes": "回",
    "longTimesTwo": "回",
    "threeTimes": "回",
    "times": "回",
    "multiplier": "倍",
    "num": "位",
    "num2": "で",
    "bets": "回",
    "skUnits": "上位"
  },
  "toast": {
    "linkCopied": "リンクをコピーしました",
    "imageSaved": "画像を保存しました"
  }
}
  